import { Endereco } from './endereco';

export class Operadora {
  public id: number;
  public nomeFantasia: string;
  public cnpj: string;
  public inscricaoEstadual: string;
  public telefone: string;
  public ativo: boolean;
  public intervaloAberturaViagem: number;
  public aprovacaoViagemEmergencial: boolean;
  public bilhetadoraId: number;
  public endereco: Endereco;

  constructor(item?) {
    if (item) {
      this.id = item.id;
      this.bilhetadoraId = item.bilhetadoraId;
      this.nomeFantasia = item.nomeFantasia;
      this.cnpj = item.cnpj;
      this.inscricaoEstadual = item.inscricaoEstadual;
      this.telefone = item.telefone;
      this.aprovacaoViagemEmergencial = item.aprovacaoViagemEmergencial;
      this.intervaloAberturaViagem = item.intervaloAberturaViagem;
      this.ativo = item.ativo;
      if (item.endereco) this.endereco = new Endereco(item.endereco);
    }
  }
}
